function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoFooter(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 162 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M67.0225 19.0288C67.8029 19.8124 68.7251 20.4289 69.789 20.8807C70.8528 21.3324 72.0359 21.5695 73.3111 21.5745C74.2556 21.5745 75.1777 21.4322 76.0527 21.1228C76.9276 20.8358 77.7304 20.4339 78.4637 19.8873C79.1746 19.3657 79.7885 18.7243 80.308 17.988C80.8275 17.2543 81.2053 16.4456 81.4414 15.5447H77.7305C77.5664 15.9714 77.3303 16.3508 77.022 16.6828C76.7138 17.0147 76.3609 17.2992 75.9582 17.5139C75.5555 17.751 75.1554 17.9406 74.7055 18.0604C74.2556 18.1777 73.7833 18.2501 73.3111 18.2501C72.5082 18.2501 71.7749 18.1079 71.1362 17.8233C70.4725 17.5638 69.9058 17.1844 69.4335 16.6853C68.9612 16.1861 68.6083 15.617 68.3473 14.9756C68.0888 14.3367 67.9695 13.6229 67.9695 12.8642C67.9695 12.1055 68.0863 11.3942 68.3473 10.7528C68.6058 10.1113 68.9612 9.54228 69.4335 9.04313C69.9082 8.54397 70.475 8.16463 71.1362 7.88011C71.7749 7.61806 72.5082 7.47577 73.3111 7.47577C73.7833 7.47577 74.2556 7.54565 74.7055 7.66545C75.1554 7.78275 75.5555 7.97245 75.9582 8.18709C76.3609 8.42419 76.7138 8.70869 77.022 9.04063C77.3278 9.37257 77.5639 9.75194 77.7305 10.1787H81.4414C81.2053 9.27774 80.8275 8.44667 80.308 7.71042C79.7885 6.97416 79.1721 6.35767 78.4637 5.8111C77.7304 5.28698 76.9276 4.88517 76.0527 4.5757C75.1777 4.29118 74.2556 4.14893 73.3111 4.14893C72.0335 4.14893 70.8528 4.36105 69.789 4.81278C68.7251 5.26452 67.8029 5.88096 67.0225 6.66464C66.242 7.44831 65.6281 8.37428 65.1782 9.44248C64.7308 10.5107 64.517 11.6487 64.517 12.8592C64.517 14.0696 64.7283 15.2077 65.1782 16.2759C65.6281 17.3441 66.242 18.2451 67.0225 19.0288Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2967 12.1968C44.8004 11.7441 44.1875 11.3889 43.5027 11.1263C42.7955 10.8662 42.0412 10.7462 41.215 10.7437H36.4187V7.70001H45.4853V4.4187H32.9746V21.3053H41.215C42.0388 21.3053 42.7955 21.1628 43.5027 20.9002C44.1875 20.6401 44.8004 20.2824 45.2967 19.8072C45.7929 19.3545 46.1924 18.7843 46.5001 18.1416C46.783 17.5013 46.9244 16.8111 46.9244 16.0258C46.9244 15.2405 46.783 14.5277 46.5001 13.8849C46.1924 13.2422 45.7929 12.6719 45.2967 12.1968ZM41.1678 13.9099C41.8998 13.9099 42.4879 14.1 42.937 14.4577C43.3861 14.8128 43.597 15.3355 43.597 16.0258C43.597 16.716 43.3861 17.2137 42.937 17.5714C42.4879 17.929 41.8998 18.1191 41.1678 18.1191H36.4187V13.9099H41.1678Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9647 4.42568V11.2987H96.9686L100.905 6.35257V11.2987H102.056V4.42568H101.052L97.1258 9.36345V4.42568H95.9647Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1969 7.67826L87.7564 4.42632H86.7035V11.2993H87.8545V6.36152L90.207 9.48877L92.5393 6.3715V11.2993H93.7004V4.42632H92.6474L90.1969 7.67826Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.539 8.91788H105.466V11.2987H104.315V4.42568H106.539C107.976 4.42568 108.959 5.40326 108.959 6.67179C108.959 7.94031 107.976 8.91788 106.539 8.91788ZM106.529 5.49138H105.466V7.85386H106.529C107.355 7.85386 107.829 7.34013 107.829 6.67345C107.829 6.00344 107.355 5.49138 106.529 5.49138Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7035 14.0982V20.9712H87.7074L91.6436 16.0251V20.9712H92.7945V14.0982H91.7906L87.8646 19.036V14.0982H86.7035Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0539 14.0982H96.2048V16.9445H99.6593V14.0982H100.81V20.9712H99.6593V18.0185H96.2048V20.9712H95.0539V14.0982Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.487 14.0982H103.077V20.9712H105.793C107.122 20.9712 108.046 20.0901 108.046 18.9579C108.046 18.1066 107.563 17.5829 106.924 17.3219C107.308 17.041 107.573 16.6153 107.573 15.9952C107.573 14.9594 106.738 14.0982 105.487 14.0982ZM106.442 16.0634C106.442 16.5954 106.059 16.9927 105.428 16.9927H104.228V15.134H105.428C106.059 15.134 106.442 15.5596 106.442 16.0634ZM106.924 18.9479C106.924 19.5281 106.512 19.9354 105.763 19.9354H104.228V17.9603H105.763C106.51 17.9603 106.924 18.376 106.924 18.9479Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.874 14.0982H114.075V15.1822H111.025V16.9445H113.486V18.0285H111.025V19.8872H114.075V20.9712H109.874V14.0982Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.013 13.9821C116.927 13.9821 115.372 15.5216 115.372 17.5349C115.372 19.5483 116.927 21.0878 119.013 21.0878C120.694 21.0878 122.033 20.0121 122.378 18.6671H121.137C120.841 19.4519 119.995 19.9939 119.011 19.9939C117.556 19.9939 116.532 18.9198 116.532 17.5349C116.532 16.15 117.554 15.076 119.011 15.076C119.996 15.076 120.841 15.618 121.137 16.4028H122.378C122.035 15.0561 120.696 13.9821 119.013 13.9821Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.506 15.1822H123.477V14.0982H128.693V15.1822H126.656V20.9712H125.506V15.1822Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.329 14.0982V20.9712H131.333L135.269 16.0251V20.9712H136.42V14.0982H135.416L131.49 19.036V14.0982H130.329Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.017 19.8872V22.4043H143.954V20.9712H138.679V14.0982H139.841V19.8872H142.971V14.0982H144.132V19.8872H145.017Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.762 14.0982V20.9712H147.765L151.702 16.0251V20.9712H152.853V14.0982H151.849L147.923 19.036V14.0982H146.762Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.113 20.9712V14.0982H156.274V19.036L160.2 14.0982H161.204V20.9712H160.053V16.0251L156.117 20.9712H155.113Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.619 12.0549H157.376C157.376 12.6352 157.711 12.9943 158.252 12.9943C158.793 12.9943 159.127 12.6368 159.127 12.0549H159.884C159.884 13.0425 159.156 13.6626 158.25 13.6626C157.348 13.6626 156.619 13.0425 156.619 12.0549Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3528 21.3053H50.0536V4.4187H53.3528V11.5765L59.2209 4.4187H63.3225L56.6296 12.5294L64.7187 21.3053H60.4109L53.3528 13.6473V21.3053Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0336 26C20.2227 26 26.0505 20.1797 26.0505 13C26.0505 5.8203 20.2227 0 13.0336 0C5.84463 0 0.0167847 5.8203 0.0167847 13C0.0167847 20.1797 5.84463 26 13.0336 26Z",
    fill: "url(#paint0_linear_2487_1059)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0336 26C20.2227 26 26.0505 20.1797 26.0505 13C26.0505 5.8203 20.2227 0 13.0336 0C5.84463 0 0.0167847 5.8203 0.0167847 13C0.0167847 20.1797 5.84463 26 13.0336 26Z",
    fill: "url(#paint1_linear_2487_1059)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92164 2.21985C1.59401 6.15131 2.06366 13.2348 6.97195 18.0395C11.8785 22.8442 19.3639 23.5538 23.6933 19.6206C24.1838 19.175 24.6127 18.689 24.9805 18.1705C25.669 16.5859 26.0507 14.8374 26.0507 13C26.0507 5.8203 20.2229 0 13.0338 0C10.6142 0 8.3487 0.659352 6.40775 1.80797C6.24169 1.9391 6.07956 2.07639 5.92164 2.21985Z",
    fill: "url(#paint2_radial_2487_1059)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.80553 2.21907C4.75724 5.33458 7.14263 10.1762 12.1342 13.0302C17.1257 15.8859 22.8308 15.674 24.8808 12.5568C25.4597 11.6765 25.6849 10.6587 25.5975 9.58699C24.0966 4.0629 19.0403 0 13.0339 0C11.22 0 9.49277 0.37054 7.92393 1.03996C7.48211 1.37072 7.10476 1.76393 6.80553 2.21907Z",
    fill: "url(#paint3_linear_2487_1059)",
    style: {}
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2487_1059",
    x1: 12.7082,
    y1: 25.675,
    x2: 12.8987,
    y2: 1.48746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E66E6",
    style: (_ref2 = {
      stopColor: "#1E66E6"
    }, _defineProperty(_ref2, "stopColor", "color(display-p3 0.1163 0.4017 0.9000)"), _defineProperty(_ref2, "stopOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#8CB4F2",
    style: (_ref3 = {
      stopColor: "#8CB4F2"
    }, _defineProperty(_ref3, "stopColor", "color(display-p3 0.5490 0.7059 0.9490)"), _defineProperty(_ref3, "stopOpacity", 1), _ref3)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F7FE",
    style: (_ref4 = {
      stopColor: "#F1F7FE"
    }, _defineProperty(_ref4, "stopColor", "color(display-p3 0.9451 0.9686 0.9961)"), _defineProperty(_ref4, "stopOpacity", 1), _ref4)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2487_1059",
    x1: 24.098,
    y1: 18.85,
    x2: 10.4433,
    y2: 8.43294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D87EA",
    style: (_ref5 = {
      stopColor: "#4D87EA"
    }, _defineProperty(_ref5, "stopColor", "color(display-p3 0.3020 0.5294 0.9176)"), _defineProperty(_ref5, "stopOpacity", 1), _ref5)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EAAF0",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2487_1059",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.4514 16.0582) rotate(-152.983) scale(30.9831 63.834)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.103242,
    stopColor: "#4382EF",
    style: (_ref6 = {
      stopColor: "#4382EF"
    }, _defineProperty(_ref6, "stopColor", "color(display-p3 0.2617 0.5098 0.9375)"), _defineProperty(_ref6, "stopOpacity", 1), _ref6)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.459935,
    stopColor: "#7EAAF0",
    style: (_ref7 = {
      stopColor: "#7EAAF0"
    }, _defineProperty(_ref7, "stopColor", "color(display-p3 0.4941 0.6667 0.9412)"), _defineProperty(_ref7, "stopOpacity", 1), _ref7)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630708,
    stopColor: "#B2CDF6",
    style: (_ref8 = {
      stopColor: "#B2CDF6"
    }, _defineProperty(_ref8, "stopColor", "color(display-p3 0.6980 0.8039 0.9647)"), _defineProperty(_ref8, "stopOpacity", 1), _ref8)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794216,
    stopColor: "#F0F6FD",
    style: (_ref9 = {
      stopColor: "#F0F6FD"
    }, _defineProperty(_ref9, "stopColor", "color(display-p3 0.9412 0.9647 0.9922)"), _defineProperty(_ref9, "stopOpacity", 1), _ref9)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2487_1059",
    x1: 24.3986,
    y1: 4.54344,
    x2: 5.87558,
    y2: 7.15663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CBFF4",
    style: (_ref10 = {
      stopColor: "#9CBFF4"
    }, _defineProperty(_ref10, "stopColor", "color(display-p3 0.6118 0.7490 0.9569)"), _defineProperty(_ref10, "stopOpacity", 1), _ref10)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476252,
    stopColor: "#CCE0FD",
    style: (_ref11 = {
      stopColor: "#CCE0FD"
    }, _defineProperty(_ref11, "stopColor", "color(display-p3 0.8000 0.8784 0.9922)"), _defineProperty(_ref11, "stopOpacity", 1), _ref11)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770833,
    stopColor: "#E9F2FE",
    style: (_ref12 = {
      stopColor: "#E9F2FE"
    }, _defineProperty(_ref12, "stopColor", "color(display-p3 0.9137 0.9490 0.9961)"), _defineProperty(_ref12, "stopOpacity", 1), _ref12)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F7FE",
    style: (_ref13 = {
      stopColor: "#F1F7FE"
    }, _defineProperty(_ref13, "stopColor", "color(display-p3 0.9451 0.9686 0.9961)"), _defineProperty(_ref13, "stopOpacity", 1), _ref13)
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logo_footer.e092e740110bc1cc22603a1fe7858e62.svg";
export { ForwardRef as ReactComponent };